import dayjs, { Dayjs } from 'dayjs';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DatePicker } from 'components/ui/DatePicker';
import { TableCellEntityMode } from 'entities/TableCell';
import { TableDateController } from 'stores/common';
import { API_TIME_DEFAULT_FORMAT } from 'utils/date';

import { TableControllerProps } from '../types';

const InputDateController: React.FC<
  TableControllerProps<TableDateController>
> = ({ record, className, params }) => {
  const handleChange = React.useCallback(
    (value: Dayjs | null) => {
      if (!value) {
        record.reset();

        return;
      }

      record.setValue(value);
    },
    [record]
  );

  const value = React.useMemo(() => {
    if (!record.controllerValue) {
      return null;
    }

    return dayjs(record.controllerValue);
  }, [record.controllerValue]);

  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  return (
    <DatePicker
      className={className}
      format={API_TIME_DEFAULT_FORMAT}
      picker="date"
      value={value}
      onChange={handleChange}
      disabled={controllerDisabled}
    />
  );
};

export default observer(InputDateController);
